import type { Age } from 'chery-contracts';

/**
 * Page 01 — the direction and the three Ages (board one-sheet, 18 Jun 2026). Narrative copy only: the gates and the
 * live actuals come from `board.direction`, so the numbers have one source (the service's `domain/age.ts`).
 */
export const DIRECTION_INTRO = {
  eyebrow: 'From the Board · Distributorship Relaunch · Page 01',
  title: 'The direction: relaunch Chery, become a top-3 Chinese brand in Jordan',
  body: 'We source vehicles from the manufacturer, import and store them, build the brand, sell through three channels, then service the cars and supply the parts. The board frames this journey as three ages — Bronze, Silver, Golden — each with a clear entry line, a clear exit line, and a widening set of responsibilities for every division.',
} as const;

export interface AgeCopy {
  /** The small line over the card (`We are here`, `2027`). */
  tag: string;
  /** The line under the gate figure. */
  unitLine: string;
  blurb: string;
}

export const AGE_COPY: Readonly<Record<Age, AgeCopy>> = {
  BRONZE: {
    tag: 'We are here',
    unitLine: 'units 2026 · exit at 100 / month',
    blurb:
      "The proving ground: relaunch the brand nationally in Q4 2026 and rebuild customer confidence after the brand's absence. The age ends the first month we repeat 100 units.",
  },
  SILVER: {
    tag: '2027',
    unitLine: 'units 2027 · 100–200 / month',
    blurb:
      'The scaling year: a continuous launch program — a new model every quarter — carried by the flagship showroom and a 20% safety-stock buffer so we never sell out of momentum.',
  },
  GOLDEN: {
    tag: '2028',
    unitLine: 'units / year · 200+ / month',
    blurb: 'Market leadership: 2,407 units planned for 2028 — 52.6M JOD in revenue — puts Chery among the top 5 Chinese brands in Jordan.',
  },
};

/** The board's own age colours (page 01 timeline: oklch(0.62 0.08 60) · oklch(0.72 0.015 260) · oklch(0.68 0.11 85)), as CSS tokens. */
export const AGE_COLOR: Readonly<Record<Age, string>> = {
  BRONZE: 'var(--age-bronze)',
  SILVER: 'var(--age-silver)',
  GOLDEN: 'var(--age-golden)',
};

export const AGES_CLOSING_NOTE =
  'Each age is an exit line, not a date: Bronze ends the first month we repeat 100 units, Silver ends at a sustained 200-unit month. The fronts advance together — a showroom without stock, or leads without service coverage, breaks the machine.';
